export default __webpack_public_path__ + "static/media/gym_fitness_low.89377b4c.svg";